import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function LandingHome() {
    const { t } = useTranslation();
    return (
        <section className="landingHome">
            <div className="container h-full flex flex-col justify-center gap-[10px]">
                <div className="flex flex-col ">
                    <div className="btmAni1256 text-[17px] text-white">{t("Welcome to")}</div>
                    <div className="btmAni2000 font-36 text-[50px] text-white font-bold">{t("Alnujoud Drug Store")}</div>
                </div>
                <p className="btmAni25002 font-13 w-100 text-white leading-[1.6] w-[66%]">
                    {t("landing text")}
                </p>
                <Link className="btmAni20002 bg-white w-fit px-[30px] py-[7px] rounded-[4px] text-[#017E89] font-bold capitalize" to={"/about"}>{t("Read More")}</Link>
            </div>
        </section>
    );
}